import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage = () => (
  <div
    className='signup-page-background'
    style={{
      backgroundColor: '#f7f7f7',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}
  >

    {/* Header */}
    <header
      className="shadow-sm py-3 px-24 d-flex align-items-center"
    >
      <Link to="/" className="d-inline-block">
        <img
          src="/assets/images/logo.png"
          alt="Logo"
          style={{ height: '40px', objectFit: 'contain' }}
        />
      </Link>
    </header>

    {/* Main Content */}
    <section
      className="auth forgot-password-page d-flex justify-content-center pt-4 px-3"
      style={{
        flex: 1,
        overflowY: 'auto',
        minHeight: 0,
      }}
    >
      <div className="d-flex flex-column">
        <div className="p-32 m-32 border rounded-2 bg-white mb-24" style={{ maxWidth: "1100px" }}>
          <h6 className="mb-4 fw-semibold">Privacy Policy – Samurai CMMS</h6>
          <p>
            The Samurai CMMS App (“we”, “our”, or “us”) is developed and
            operated by Samurai Software Pty Ltd, an Australian software
            development company. This Privacy Policy explains how we handle your
            information when you use our Samurai CMMS mobile application (“the App”).
          </p>

          <h6 className="mt-4 text-xl mt-12">Information We Collect</h6>
          <p>When you use the App, we may collect the following types of information:</p>
          <ul>
            <li className="ms-16">• Account information such as your name, email address and login credentials.</li>
            <li className="ms-16">• Usage data including actions taken within the App.</li>
            <li className="ms-16">• Device information such as device model, operating system and app version.</li>
            <li className="ms-16">• Optional media such as photos or attachments that you upload, which are stored securely.</li>
          </ul>

          <h6 className="mt-4 text-xl mt-12">How We Use Information</h6>
          <p>We use collected information to:</p>
          <ul>
            <li className="ms-16">• Provide and improve the CMMS features of the App.</li>
            <li className="ms-16">• Authenticate users and maintain secure access.</li>
            <li className="ms-16">• Store and display work order, asset and maintenance information.</li>
            <li className="ms-16">• Communicate with users regarding support, updates and service notifications.</li>
            <li className="ms-16">• Comply with applicable Australian laws and regulations.</li>
          </ul>

          <h6 className="mt-4 text-xl mt-12">Sharing of Information</h6>
          <p>We do not sell or rent your personal information. We may share data only in these cases:</p>
          <ul>
            <li className="ms-16">• With your organisation if your employer provides access to Samurai CMMS. Authorised administrators may access your submitted data.</li>
            <li className="ms-16">• With service providers such as hosting, storage or analytics providers who support our services under confidentiality obligations.</li>
            <li className="ms-16">• If required by law to comply with a legal obligation, court order or regulatory requirement.</li>
          </ul>

          <h6 className="mt-4 text-xl mt-12">Data Storage and Security</h6>
          <p>
            Data is stored on secure servers on managed servers located Sydney Australia.
            We apply industry standard security practices, including encryption in transit (HTTPS).
            Access to your account is protected by your login credentials, which you are
            responsible for keeping secure.
          </p>

          <h6 className="mt-4 text-xl mt-12">Data Retention</h6>
          <p>
            We retain your information for as long as your organisation uses Samurai CMMS.
            If your account is deleted, we will remove or anonymise your data within a reasonable
            period unless retention is required by law.
          </p>

          <h6 className="mt-4 text-xl mt-12">Your Rights</h6>
          <p>As an Australian user, you may have rights under the Privacy Act 1988 (Cth), including:</p>
          <ul>
            <li className="ms-16">• Accessing the personal information we hold about you.</li>
            <li className="ms-16">• Requesting correction of inaccurate or outdated information.</li>
            <li className="ms-16">• Contacting us to raise privacy concerns.</li>
          </ul>

          <h6 className="mt-4 text-xl mt-12">Children’s Privacy</h6>
          <p>
            The App is intended for business and organisational use only. It is not directed at
            children under 16 and we do not knowingly collect information from children.
          </p>

          <h6 className="mt-4 text-xl mt-12">Changes to This Policy</h6>
          <p>
            We may update this Privacy Policy from time to time. Updates will be posted here.
          </p>

          <h6 className="mt-4 text-xl mt-12">Contact Us</h6>
          <p>If you have any questions about this Privacy Policy or how we handle your data, please contact us at:</p>
          <p className="mb-0">Samurai Software Pty Ltd</p>
          <p className="mb-0">ABN 58 687 870 711</p>
          <p>Email: <a href="mailto:support@samurai-cmms.com.au">support@samurai-cmms.com.au</a></p>
        </div>
      </div>
    </section>
  </div>
);

export default PrivacyPolicyPage;
